// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".current-logo[data-v-75875bf8]{height:40px;margin-right:1rem}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Settings/Logo/Edit.vue"],"names":[],"mappings":"AACA,+BACI,WAAA,CACA,iBAAJ","sourcesContent":["\n.current-logo {\n    height: 40px;\n    margin-right: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
